module.exports = __webpack_public_path__ + "img/icone-filtro.d9f08206.svg";